import { NAVIGATOR_CONFIG } from "../../headless/children";
function StackHeaderLeft(_props) {
  return null;
}
Object.assign(StackHeaderLeft, {
  [NAVIGATOR_CONFIG]: true
});
function appendStackHeaderLeftPropsToOptions(options, props) {
  if (!props.asChild) {
    return options;
  }
  return {
    ...options,
    headerLeft: function headerLeft() {
      return props.children;
    }
  };
}
export {
  StackHeaderLeft,
  appendStackHeaderLeftPropsToOptions
};
//# sourceMappingURL=StackHeaderLeft.js.map
